module.exports = __webpack_public_path__ + "static/media/image_ng.ef28eb3c.svg";